import { render, staticRenderFns } from "./RIST.vue?vue&type=template&id=ed035d8e&scoped=true&"
import script from "./RIST.vue?vue&type=script&lang=ts&"
export * from "./RIST.vue?vue&type=script&lang=ts&"
import style0 from "./RIST.vue?vue&type=style&index=0&id=ed035d8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed035d8e",
  null
  
)

export default component.exports